module.exports = __webpack_public_path__ + "static/media/card-2.fb513689.jpeg";